// extracted by mini-css-extract-plugin
export default {"confirmModalText":"CSVFileErrorModal_confirmModalText__E6fSL","confirmModalBtnGroup":"CSVFileErrorModal_confirmModalBtnGroup__iCn3j","groupBtn2":"CSVFileErrorModal_groupBtn2__3l1Fs"};